import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { type FormatDurationOptions, formatTimeAsHoursMinutesAndSeconds } from "verdi-common/utils/timeUtils";
import { NAMESPACES } from "@/i18n/constants";
import type { Translate } from "@/i18n/types";

export type DurationFormatOptions = Pick<FormatDurationOptions, "includeSecondsWithMinutes" | "omitZeroUnits">;

/** A duration such as "1hr 15min" with translated unit labels. `tTime` is the common namespace under the `time` prefix. */
export function formatDuration(ms: number, tTime: Translate, options: DurationFormatOptions = {}): string {
    return formatTimeAsHoursMinutesAndSeconds(ms, {
        ...options,
        hourLabel: tTime("hour.short"),
        minuteLabel: tTime("minute.short"),
        secondLabel: tTime("second.short"),
    });
}

export function useFormatDuration(): (ms: number, options?: DurationFormatOptions) => string {
    const { t: tTime } = useTranslation(NAMESPACES.COMMON, { keyPrefix: "time" });
    return useCallback((ms, options) => formatDuration(ms, tTime, options), [tTime]);
}
